import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components6';
import { Else, If, Then, When } from 'react-if';
import { VerticalDivider } from '../../components/Divider';

interface SplitNavigationButtonsProps {
    currentIndex: number;
    onNext: () => void;
    onPrev: () => void;
    hasMore: boolean;
    nextText?: string;
    prevText?: string;
}

const BUTTON_HEIGHT = '38px';

const Container = styled.div`
    display: flex;
    width: 100%;
    border: 1px solid var(--rwl-palette-gray-300);
    border-radius: var(--rwl-radius-lg);
    height: ${BUTTON_HEIGHT};
`;

export const SplitButton = styled.button.withConfig({
    shouldForwardProp: (prop) => prop !== 'fullWidth', //remove console warning of invalid prop passed to HTML element
})<{ fullWidth?: boolean }>`
    flex: ${({ fullWidth }) => (fullWidth ? 1 : '0.5')};
    border: none;
    padding: 10px;
    background-color: transparent;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const NextArrow = styled(FontAwesomeIcon)`
    margin-left: var(--rwl-spacing-md);
`;

const PrevArrow = styled(FontAwesomeIcon)`
    margin-right: var(--rwl-spacing-md);
`;

export const SplitNavigationButtons: React.FC<SplitNavigationButtonsProps> = (
    props
) => (
    <Container>
        <BigButton {...props} />
        <SplitButtons {...props} />
    </Container>
);

const BigButton = ({
    hasMore,
    currentIndex,
    onNext,
    onPrev,
    nextText,
    prevText,
}: SplitNavigationButtonsProps) => (
    <When condition={currentIndex === 0 || !hasMore}>
        <SplitButton fullWidth onClick={() => (hasMore ? onNext() : onPrev())}>
            <If condition={hasMore}>
                <Then>
                    {nextText}
                    <NextArrow icon={faChevronRight} />
                </Then>
                <Else>
                    <PrevArrow icon={faChevronLeft} />
                    {prevText}
                </Else>
            </If>
        </SplitButton>
    </When>
);

const SplitButtons = ({
    hasMore,
    currentIndex,
    onNext,
    onPrev,
    prevText,
    nextText,
}: SplitNavigationButtonsProps) => (
    <When condition={currentIndex > 0 && hasMore}>
        <SplitButton onClick={() => onPrev()}>
            <PrevArrow icon={faChevronLeft} />
            {prevText ? prevText : ''}
        </SplitButton>
        <VerticalDivider />
        <SplitButton onClick={() => onNext()}>
            {nextText ? nextText : ''}
            <NextArrow icon={faChevronRight} />
        </SplitButton>
    </When>
);
